import { TrendDown, TrendUp, ArrowRight } from "@phosphor-icons/react";
import { fmtDate } from "@/lib/format";

const Row = ({ m, tone, onSelectBuyer }) => (
  <button
    onClick={() => onSelectBuyer(m.buyer)}
    data-testid={`mover-${tone}-${m.buyer}`}
    className="flex w-full items-center justify-between gap-3 border-b border-[#E3E7EC]/60 py-2 text-left transition-colors last:border-0 hover:bg-[#EDEFF3]"
  >
    <span className="min-w-0 flex-1 truncate text-sm text-[#0F172A]">{m.buyer}</span>
    <span className="flex items-center gap-1.5 font-mono text-xs text-[#64748B]">
      {m.from}d <ArrowRight size={11} className="text-[#CAD1DB]" /> {m.to}d
    </span>
    <span className={`w-12 text-right font-mono text-sm font-semibold ${tone === "improved" ? "text-emerald-600" : "text-red-600"}`}>
      {m.delta > 0 ? "+" : ""}{m.delta}d
    </span>
  </button>
);

const Empty = ({ text }) => (
  <div className="py-4 text-center text-xs text-[#9CA3AF]">{text}</div>
);

export const BiggestMovers = ({ movers, onSelectBuyer }) => {
  const hasData = movers && (movers.improved?.length || movers.slipped?.length);

  return (
    <div className="col-span-12 border border-[#E3E7EC] bg-white p-5 lg:col-span-4" data-testid="biggest-movers">
      <div className="mb-4">
        <h3 className="text-sm font-semibold text-[#0F172A]">Biggest Movers</h3>
        <p className="pf-label mt-0.5">
          Turnaround change per buyer{movers?.prev_reference_date ? ` vs ${fmtDate(movers.prev_reference_date)}` : ""}
        </p>
      </div>

      {!movers ? (
        <Empty text="Upload the report on another day to see who improved or slipped." />
      ) : !hasData ? (
        <Empty text="No buyer movement between the two snapshots." />
      ) : (
        <div className="space-y-4">
          <div>
            <div className="mb-1 flex items-center gap-1.5 text-emerald-600">
              <TrendDown size={15} weight="bold" />
              <span className="pf-label text-emerald-600">Improved</span>
            </div>
            {movers.improved.length ? (
              movers.improved.map((m) => <Row key={m.buyer} m={m} tone="improved" onSelectBuyer={onSelectBuyer} />)
            ) : (
              <Empty text="None improved" />
            )}
          </div>
          <div>
            <div className="mb-1 flex items-center gap-1.5 text-red-600">
              <TrendUp size={15} weight="bold" />
              <span className="pf-label text-red-600">Slipped</span>
            </div>
            {movers.slipped.length ? (
              movers.slipped.map((m) => <Row key={m.buyer} m={m} tone="slipped" onSelectBuyer={onSelectBuyer} />)
            ) : (
              <Empty text="None slipped" />
            )}
          </div>
        </div>
      )}
    </div>
  );
};
